<template lang="pug">
  extends TableRowBase.pug
</template>

<script>
  import TableRowBase from './TableRowBase.vue';

  export default {
    name: 'TableRowDollarRefundRate',
    extends: TableRowBase,
    methods: {
      getCalculatedYtd(yearObj, throughMonth) {
        return this.getRatio(
          this.getYtdByField(yearObj, 'ha_money_refunded', throughMonth),
          this.getYtdByField(yearObj, 'gross_ha_revenue', throughMonth),
          0,
        );
      },
    },
  };
</script>
